import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

interface Props {
  checked?: boolean;
  onClick?: (e: ElementMouseEvent) => void;
}

export default function Checkbox(props: Props): JSX.Element {
  return (
    <div
      className={classNames({
        'step-checkbox': true,
        checked: props.checked,
      })}
      onClick={props.onClick}
    >
      <BenchlingIcon icon="check" />
    </div>
  );
}
